const values = [
  ["Simple ticket buying", "Discover an event, understand what you are buying, and get your ticket without unnecessary friction."],
  ["Made for live events", "AnTix is built for concerts, nightlife, parties, community events, and the people who bring them to life."],
  ["Digital tickets, easier entry", "Clear ticket details and digital tickets help guests and event teams move through the door with confidence."],
  ["Built with purpose", "AnTix was founded and built with a focus on practical tools for real events—not unnecessary complexity."]
];

export default function AboutPage() {
  return (
    <section className="page about-page" aria-labelledby="about-title">
      <section className="about-hero" aria-labelledby="about-title">
        <div className="eyebrow">About AnTix</div>
        <h1 id="about-title">Events should be easy to find. Tickets should be easy to get.</h1>
        <p>AnTix is a modern event ticketing and discovery platform built to help people find live events, buy tickets, and get through the door with ease.</p>
        <div className="hero-actions"><a className="primary-action" href="/tickets">Browse Events</a></div>
      </section>

      <section className="about-section" aria-labelledby="why-antix">
        <h2 id="why-antix">Why AnTix exists</h2>
        <p>AnTix was built around a simple idea: people should be able to find an event, understand what they are buying, get their ticket, and get through the door without unnecessary friction.</p>
        <p>The platform connects attendees with the events they want to experience while giving event organizers practical tools to run ticket sales and entry.</p>
      </section>

      <section className="about-grid" aria-label="Who AnTix is for">
        <article className="about-card">
          <h2>Built for the people going out.</h2>
          <p>Discover upcoming events, see the details in one place, buy event tickets online, and keep digital tickets ready for a smoother night out.</p>
        </article>
        <article className="about-card">
          <h2>Built for the people creating the night.</h2>
          <p>Event organizers can create and manage events, offer ticket tiers, follow ticket sales, review attendee lists, and manage scanning and check-in at the door.</p>
          <p>As AnTix grows, organizer onboarding is being expanded toward a more direct self-service experience.</p>
        </article>
      </section>

      <section className="about-section" aria-labelledby="what-matters">
        <h2 id="what-matters">What matters to AnTix</h2>
        <div className="about-values">
          {values.map(([title, copy]) => <article className="about-value" key={title}><h3>{title}</h3><p>{copy}</p></article>)}
        </div>
      </section>

      <section className="about-section about-founder" aria-labelledby="built-with-purpose">
        <h2 id="built-with-purpose">Built with purpose</h2>
        <p>AnTix was founded and built to create a simpler, more modern event ticketing experience for both attendees and organizers. It continues to evolve around the needs of people attending events and the teams making them happen.</p>
      </section>

      <section className="about-section" aria-labelledby="where-going">
        <h2 id="where-going">Where AnTix is going</h2>
        <p>AnTix is continuing to improve event discovery, organizer tools, ticket sales, and the ticketing and entry experience. The aim is to make it easier for organizers to get started and run events from one practical platform.</p>
      </section>

      <section className="about-cta" aria-labelledby="find-next-event">
        <h2 id="find-next-event">Find your next event.</h2>
        <p>Browse upcoming live events and see what is happening next.</p>
        <a className="primary-action" href="/tickets">Browse Events</a>
      </section>
    </section>
  );
}
